import Grid from '@/global/components/ui/Grid'
import { FormDatePicker, FormFieldSelect } from 'global/components/Form'
import { SelectEmpresa, SelectFuncionarios } from 'global/components/Selects'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import {
    CreateTabelaHorarioFuncionarioSchema,
    funcionario,
    tabelaHorarios,
    trocaHorario,
} from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'
import { z } from 'zod'

export default function AdicionarTrocaTabelaHorario() {
    const empresaId = useStore(state => state.companyId)
    const { data = [] } = tabelaHorarios.useFetch({
        refetchOnWindowFocus: false,
    })
    const { mutateAsync, isLoading } = trocaHorario.mutations.useCreate({
        invalidateQuery: true,
    })

    function handleSubmit(
        values: z.infer<typeof CreateTabelaHorarioFuncionarioSchema> & {
            funcionarioIds: number[]
        },
    ) {
        return mutateAsync({ ...values, empresaId } as any, {
            onSuccess: () => {
                toast.success('Troca criada com sucesso!')
                funcionario.invalidateQueries()
            },
            onError: err => {
                toast.error(err.message)
            },
        })
    }

    return [
        <Dialog.Root
            open={hasPermission(['create', 'TrocaDeTabelaDeHorário'])}
            width="lg"
            onSubmit={handleSubmit}
            loading={isLoading}
            schema={CreateTabelaHorarioFuncionarioSchema.omit({
                funcionarioId: true,
                empresaId: true,
            }).extend({
                funcionarioIds: z.array(z.coerce.number()).nonempty(),
            })}
        >
            <Dialog.Title>Troca de tabela de horário</Dialog.Title>
            <Dialog.Content>
                <Grid container>
                    <Grid item xs={12}>
                        <SelectEmpresa variant="form" />
                    </Grid>
                    <Grid item xs={12}>
                        <SelectFuncionarios variant="form" form />
                    </Grid>
                    <Grid item xs={12}>
                        <FormFieldSelect
                            label="Tabela de horário"
                            name="tabelaHorarioId"
                            required
                            options={data.map(tabela => ({
                                label: tabela.nome,
                                value: tabela.id.toString(),
                            }))}
                            className="mb-4"
                        />
                    </Grid>
                    <Grid item xs={12} sm={5}>
                        <FormDatePicker
                            label="Data inicial"
                            name="dtInicial"
                            type="date"
                            required
                        />
                    </Grid>
                    <Grid item xs={12} sm={7}>
                        <FormDatePicker
                            label="Data final"
                            name="dtFinal"
                            type="date"
                            helperText="Deixe em branco para indeterminado"
                        />
                    </Grid>
                </Grid>
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>,
    ]
}
